const AUTH_TOKEN_KEYS = [
    "authToken",
    "auth_token",
    "jwt_token",
    "access_token",
    "token",
    "user_token",
] as const;

const normalizeTokenValue = (value: unknown): string => {
    if (typeof value !== "string") return "";
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : "";
};

const normalizeIdValue = (value: unknown): string => {
    if (typeof value !== "string") return "";
    const trimmed = value.trim();
    return trimmed.length > 0 ? trimmed : "";
};

const decodeJwtPayload = (token: string): Record<string, unknown> | null => {
    if (!token) return null;
    try {
        const [, rawPayload] = token.split(".");
        if (!rawPayload) return null;
        const normalized = rawPayload.replace(/-/g, "+").replace(/_/g, "/");
        const paddingLength = (4 - (normalized.length % 4)) % 4;
        const padded = normalized.padEnd(normalized.length + paddingLength, "=");
        const payload = JSON.parse(atob(padded));
        return payload && typeof payload === "object" ? (payload as Record<string, unknown>) : null;
    } catch {
        return null;
    }
};

export const getStoredAuthToken = (): string => {
    if (typeof window === "undefined") return "";

    const storages: Storage[] = [window.localStorage, window.sessionStorage];
    for (const storage of storages) {
        for (const key of AUTH_TOKEN_KEYS) {
            const token = normalizeTokenValue(storage.getItem(key));
            if (token) {
                return token;
            }
        }
    }

    return "";
};

export const getStoredAuthUserId = (): string => {
    if (typeof window === "undefined") return "";

    const token = getStoredAuthToken();
    const tokenPayload = decodeJwtPayload(token);
    const tokenUserId = normalizeIdValue(
        tokenPayload?.user_id ??
            tokenPayload?.id ??
            (typeof tokenPayload?.sub === "string" && !tokenPayload.sub.includes("@")
                ? tokenPayload.sub
                : "")
    );
    if (tokenUserId) return tokenUserId;

    if (!token) return "";

    try {
        const rawUser = window.localStorage.getItem("user");
        const parsedUser = rawUser ? JSON.parse(rawUser) : null;
        return normalizeIdValue(parsedUser?.id ?? parsedUser?.user_id ?? parsedUser?.userId);
    } catch {
        return "";
    }
};
